// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"194":"8d20231d","481":"d5c8bfd7","672":"0f2c7a72","787":"97b42a30","840":"c7747692"}[chunkId] + ".chunk.js";
};